import { render, staticRenderFns } from "./NotFoundScreen.vue?vue&type=template&id=6f88eede&scoped=true&"
import script from "./NotFoundScreen.vue?vue&type=script&lang=js&"
export * from "./NotFoundScreen.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundScreen.vue?vue&type=style&index=0&id=6f88eede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88eede",
  null
  
)

export default component.exports